class Source {
  constructor() {
    this.embeddable = true
    this.inputs = {
      MAIN: "48",
      VOD: "43",
      HLS: "43",
      MULTICAST: "45",
      RF: "0",
      HDMI1: "31",
      HDMI2: "32",
      HDMI3: "33"
    }
    this.pluginTVMW = null
  }
  _init = async () => {
    this.pluginTVMW = document.getElementById("pluginObjectTVMW")

    const current = this.get()
    if (current !== this.inputs.MAIN) this.set(this.inputs.MAIN)

    return true
  }
  get = async () => {
    return this.pluginTVMW.GetSource().toString()
  }
  set = async source => {
    const res = __._source.pluginTVMW.SetSource(parseInt(source, 10))

    return res > 0 ? true : false
  }
}

export default Source
